// @core/api/endpoints/localization/bulk_import_translations.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  BulkImportTranslationsRequest,
  BulkImportTranslationsResponse,
} from '../../../types/localization';

const BASE_PATH = '/localization';

/**
 * Bulk import translations
 * Imports translations from a file (JSON, XLIFF, PO, CSV). Supports create and update modes.
 */
export async function BulkImportTranslations(
  data: BulkImportTranslationsRequest,
  options?: RequestOptions
): Promise<BulkImportTranslationsResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/localization/translations/import`;
  const requestOptions = options;
  return client.post<BulkImportTranslationsResponse>(requestPath, data, requestOptions);
}
